module.exports = __webpack_public_path__ + "static/mxbcs-d9a8ed569cda4745ce43d6bfc9cf4b70.wav";